import { render } from "./BatchProcessing.vue?vue&type=template&id=bad32b82&scoped=true"
import script from "./BatchProcessing.vue?vue&type=script&lang=js"
export * from "./BatchProcessing.vue?vue&type=script&lang=js"

import "./BatchProcessing.vue?vue&type=style&index=0&id=bad32b82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad32b82"]])

export default __exports__